import api from "./axios";

export interface WarehouseIssueItemDto {
  productId: number;
  quantity: number;
  price: number;
}

export interface WarehouseIssueDto {
  id: number;
  date: string;
  createdAt: string;
  posted: boolean;
  reason: string | null;
  comment: string | null;
  items: Array<{
    id: number;
    quantity: number;
    price: number;
    product: { id: number; nameRu: string; sku: string };
  }>;
  total: number;
  createdBy?: { firstName: string; lastName: string };
}

export interface CreateIssueDto {
  date: string;
  reason?: string;
  comment?: string;
  items: WarehouseIssueItemDto[];
}

export async function getIssues(): Promise<WarehouseIssueDto[]> {
  const res = await api.get("/warehouse/issues");
  return res.data;
}

export async function createIssue(dto: CreateIssueDto): Promise<WarehouseIssueDto> {
  const res = await api.post("/warehouse/issues", dto);
  return res.data;
}

export async function updateIssue(id: number, dto: CreateIssueDto): Promise<WarehouseIssueDto> {
  const res = await api.put(`/warehouse/issues/${id}`, dto);
  return res.data;
}

export async function postIssue(id: number): Promise<void> {
  await api.post(`/warehouse/issues/${id}/post`);
}

export async function unpostIssue(id: number): Promise<void> {
  await api.post(`/warehouse/issues/${id}/unpost`);
}

export async function deleteIssue(id: number): Promise<void> {
  await api.delete(`/warehouse/issues/${id}`);
}
